import { render } from "./UploadBaa.vue?vue&type=template&id=001e82d4&ts=true"
import script from "./UploadBaa.vue?vue&type=script&lang=ts"
export * from "./UploadBaa.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__